import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { InlineWidget } from 'react-calendly'

import context from '../core/context'

function CalendlyStep({ labels, dark }) {
  const { setStep } = useContext(context)

  const goBack = () => {
    setStep(0)
    document.dispatchEvent(new CustomEvent('step-updated'))
  }

  if (labels.step_4.calendly_url) {
    return (
      <div className="developer-search__view">
        <div className="developer-search__header">
          {labels.headline && (
            <h2
              className={`headline headline--hero ${dark ? 'text-white' : 'text-deep-blue'}`}
              dangerouslySetInnerHTML={{ __html: labels.headline }}
            />
          )}
          <div className="developer-search__view__header">
            {labels.step_4.headline && (
              <h3 className={`headline headline--md ${dark ? 'text-white' : 'text-deep-blue'}`}>
                {labels.step_4.headline}
              </h3>
            )}
          </div>
        </div>
        <div className="developer-search__calendly">
          <InlineWidget url={labels.step_4.calendly_url} />
        </div>
      </div>
    )
  }

  return (
    <div className="developer-search__view">
      <div className="developer-search__header">
        {labels.headline && (
          <h2
            className={`headline headline--hero ${dark ? 'text-white' : 'text-deep-blue'}`}
            dangerouslySetInnerHTML={{ __html: labels.headline }}
          />
        )}
        <div className="developer-search__view__header">
          {labels.step_4.headline && (
            <h3 className={`headline headline--md ${dark ? 'text-white' : 'text-deep-blue'}`}>
              {labels.step_4.headline}
            </h3>
          )}
        </div>
      </div>
      <div className="developer-search__wrapper">
        <p className={`text text--lg align-center ${dark ? 'text-white' : 'text-deep-blue'}`}>
          Your information has been sent succesfully, soon our team will be contacting you with the
          necesary information
        </p>
        <div className="developer-search__nav">
          <button
            className={`btn ${dark ? 'btn--green text-white' : 'btn--white text-deep-blue'}`}
            type="button"
            onClick={goBack}
          >
            Return to talents
          </button>
        </div>
      </div>
    </div>
  )
}

CalendlyStep.propTypes = {
  labels: PropTypes.object.isRequired,
  dark: PropTypes.bool.isRequired,
}

export default CalendlyStep
